import { gql } from "@apollo/client/core";
import type { LocaleType } from "lib/apollo/types";
import { createRequestContext, getClient } from "lib/apolloClient";
import { useEffect, useState } from "react";

const NOTIFY_BACK_IN_STOCK = gql`
  mutation notifyBackInStock(
    $email: String!
    $variantSku: String!
    $locale: String!
  ) {
    notifyBackInStock(email: $email, variantSku: $variantSku, locale: $locale)
  }
`;
const storageKey = "PDPEmailNotification";
export interface OOSEmailReminderHook {
  emailSent: boolean;
  checkOOSStorage: () => boolean;
  setOOSStorage: () => void;
  handleOutOfStockEmail: (
    email: string,
    locale: LocaleType
  ) => Promise<boolean>;
}
export const useOOSEmailReminder = (
  variantSku: string
): OOSEmailReminderHook => {
  const [emailSent, setEmailSent] = useState(false);
  const checkOOSStorage = (): boolean => {
    if (typeof localStorage !== "undefined") {
      const list: string[] = JSON.parse(
        localStorage.getItem(storageKey) || "[]"
      );
      return list.includes(variantSku);
    }
    return false;
  };
  const setOOSStorage = (): void => {
    const list = localStorage.getItem(storageKey) || "[]";
    localStorage.setItem(
      storageKey,
      JSON.stringify([...JSON.parse(list), variantSku])
    );
    setEmailSent(true);
  };
  const handleOutOfStockEmail = async (
    email: string,
    locale: LocaleType
  ): Promise<boolean> => {
    const { data } = await getClient().mutate({
      mutation: NOTIFY_BACK_IN_STOCK,
      variables: {
        email,
        variantSku,
        locale
      },
      context: createRequestContext({ sessionStrategy: "START_NEW_ANONYMOUS" })
    });
    if (data.notifyBackInStock) {
      setOOSStorage();
    }
    return data.notifyBackInStock;
  };

  useEffect(() => {
    setEmailSent(checkOOSStorage());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [variantSku]);

  return {
    emailSent,
    checkOOSStorage,
    setOOSStorage,
    handleOutOfStockEmail
  };
};
